import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';

@Component({
  selector: 'lib-report-an-error-dialog',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatDialogModule],
  templateUrl: './report-an-error-dialog.component.html',
  styleUrl: './report-an-error-dialog.component.scss',
})
export class ReportAnErrorDialogComponent {
  errorForm: FormGroup;

  constructor(
    // eslint-disable-next-line no-unused-vars
    public dialogRef: MatDialogRef<ReportAnErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      litigationTitle: string;
    },
    // eslint-disable-next-line no-unused-vars
    private formBuilder: FormBuilder
  ) {
    this.errorForm = this.formBuilder.group({
      subject: ['', Validators.required],
      message: ['', Validators.required],
    });
  }

  save(): void {
    if (this.errorForm.valid) {
      this.dialogRef.close({
        subject: this.errorForm.value.subject,
        message: this.errorForm.value.message,
      });
    }
  }
  close(): void {
    this.dialogRef.close();
  }
}
